import { TreeNode } from '../../hooks/stores/launcherElementsStore';

export const treeMap = (
  treeData: TreeNode[],
  accessor: (node: TreeNode) => TreeNode[],
  callback: (node: TreeNode) => TreeNode
): TreeNode[] => {
  const tree = [...treeData];

  const flattenNode = (node: TreeNode) => {
    node = callback(node);
    const children = accessor(node);
    if (children && children.length > 0) {
      for (const child of children) {
        flattenNode(child);
      }
    }
  };

  for (const rootNode of tree) {
    flattenNode(rootNode);
  }

  return tree;
};
